import { animateScroll } from 'react-scroll';

import logger from 'utils/logger.util';

const L = logger('pageScrollToTop');

const pageScrollToTop = () => {
  try {
    animateScroll.scrollToTop();
  } catch (e) {
    L.warn('()', e);
  }
};

export default pageScrollToTop;
